var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('OfficialsPgHeader'),_c('section',{staticClass:"form-full-width"},[_c('FormOfficialsPg',{attrs:{"loading":_vm.loading,"getOfficialsPg":_vm.getOfficialsPg},on:{"beforeUpdate":_vm.updateOfficialsPg}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }